import React, { useState, useEffect } from "react";
import Alert from "../../components/Alert";
import Loading from "../../components/Loading";
import Pagination from "../../components/Pagination";
import ReactPaginate from "react-paginate";
import Table from "../../components/Table";
import Layout from "../../layout/Layout";
import { getCommuneByVille } from "../../services/commune";
import { getPays } from "../../services/pays";
import { getQuartierByCommune } from "../../services/quartier";
import { getVillesByPays } from "../../services/ville";
import {
  createOperateurImmobilier,
  getOperateurImmobilier,
  updateOperateurImmobilier,
  deleteOperateurImmobilier
} from "../../services/operateurImmobilier";
const OperateurImmobiliers = () => {
  const headTable = [
    { name: "Libellé", width: "75%" },
    // { name: "contact", width: "15%" },
    { name: "", with: "5%" },
  ];
  const [current, setCurrent] = useState(null);
  const [communes, setCommunes] = useState([]);
  const [quartiers, setQuartiers] = useState([]);
  const [pays, setPays] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [villes, setVilles] = useState([]);
  const [flash, setFlash] = useState({ message: null, color: "success" });
  const [operateurImmobiliers, setOperateurImmobiliers] = useState([]);

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const [values, setValues] = useState({
    nom: "",
    idquartier: "",
    contact: "",
    localisation: "",
    adresse: "",
    email: "",
    contactp: "",
    num: "",
  });
  const _getPays = async () => {
    const { data } = await getPays();
    setPays(data);
  };
  // pagination code
  let PageSize = 10;

  const [currentTableData, setCurrentTableData] = useState([]);

  const [totalPage, setTotalPage] = useState(null);
  const page = (currentPage, datas) => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;

    return datas.slice(firstPageIndex, lastPageIndex);
  };

  const onPageChange = (e) => {
    const d = page(parseInt(e.selected + 1), operateurImmobiliers);
    setCurrentTableData(d);
    // console.log(d);
  };
  //fince
  const onSelectPays = async (e) => {
    setIsLoading(true);
    setValues({ ...values, idpays: e.target.value });
    setCurrentTableData([]);
    setVilles([]);
    setCommunes([]);
    setQuartiers([]);
    getVillesByPays({ id: e.target.value })
      .then((res) => {
        const { data } = res;
        setVilles(data);
        setIsLoading(false);
        // console.log(data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSelectVille = (e) => {
    setIsLoading(true);
    setValues({ ...values, idville: e.target.value });
    setCommunes([]);
    setQuartiers([]);
    getCommuneByVille({ idville: e.target.value })
      .then((res) => {
        // console.log(res);
        const { data } = res;
        setCommunes(data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSelectCommune = (e) => {
    setIsLoading(true);
    setValues({ ...values, idcommune: e.target.value });
    setQuartiers([]);
    getQuartierByCommune({ idcommune: e.target.value })
      .then((res) => {
        // console.log(res);
        const { data } = res;
        setQuartiers(data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const onSelectQuartier = (e) => {
    setIsLoading(true);
    setValues({ ...values, idquartier: e.target.value });
    setOperateurImmobiliers([]);
    // listeOperateurImmobilier(e.target.value, true)
    getOperateurImmobilier(e.target.value)
      .then((res) => {
        // console.log(res);
        const { data } = res;
        setFlash({ message: data.message, color: "success" });
        const d = page(1, data.data);
        setCurrentTableData(d);
        const coutPage = parseInt(data.data.length / PageSize);
        setTotalPage(coutPage);
        setOperateurImmobiliers(data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const listeOperateurImmobilier = (id, ismessage = false) => {
    getOperateurImmobilier(id)
      .then((res) => {
        // console.log(res);
        const { data } = res;
        if (ismessage) {
          setFlash({ message: data.message, color: "success" });
        }
        const d = page(1, data.data);
        setCurrentTableData(d);
        const coutPage = parseInt(data.data.length / PageSize);
        setTotalPage(coutPage);
        setOperateurImmobiliers(data.data);
        setIsLoading(false);

      })
      .catch((err) => {
        // console.log(err);

      });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (current) {
      // update
      const update = { ...values, id: current.ID };

      const idquartier = values.idquartier
      if (update.idquartier.length === 0 || update.nom.length === 0 || update.id.length === 0) {
        setFlash({ message: "Veuillez saisir les champs requis", color: "danger" });
        setIsLoading(false);
        return false;
      }
      updateOperateurImmobilier(update)
        .then((res) => {
          setFlash({ message: res.data.message, color: "success" });
          console.log(current.IDQUARTIER);
          listeOperateurImmobilier(idquartier)
          for (const key in values) {
            if (Object.hasOwnProperty.call(values, key)) {
              values[key] = ''

            }
          }
          setValues(values);
          // getOperateurImmobilier({ idquartier: current.IDQUARTIER })
          //   .then((res) => {
          //     // console.log(res);
          //     const { data } = res;
          //     const d = page(1, data);
          //     setCurrentTableData(d);
          //     const coutPage = parseInt(data.length / PageSize);
          //     setTotalPage(coutPage);
          //     setOperateurImmobiliers(data);
          //     setIsLoading(false);
          //     setCurrent(null);
          //     setValues({ ...values, libelle: "" });
          //     // for (const value in values) {
          //     //   if (Object.hasOwnProperty.call(values, value)) {
          //     //     values[value] = "";
          //     //     setValues({ values });
          //     //   }
          //     // }
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
        })
        .catch(({ response }) => {
          setFlash({ message: response.data.message, color: "danger" });
        });
    } else {
      //  create
      if (values.idquartier.length === 0 || values.nom.length === 0) {
        setFlash({ message: "Veuillez saisir les champs requis", color: "danger" });
        setIsLoading(false);
        return false;
      }
      createOperateurImmobilier(values)
        .then((res) => {
          console.log(res);
          setFlash({ message: res.data.message, color: "success" });
          setValues({ ...values, nom: "", contact: "", localisation: "", adresse: "", email: "", num: "", contactp: "", });
          getOperateurImmobilier(values.idquartier)
            .then((res) => {
              console.log(res);
              const { data } = res;
              const d = page(1, data.data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.data.length / PageSize);
              setTotalPage(coutPage);
              setOperateurImmobiliers(data.data);
              setIsLoading(false);
              //
              setValues({ ...values, libelle: "" });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((res) => {
          // console.log(err)
          setFlash({ message: res.data.message, color: "danger" });
        });
    }
  };
  const [_idQuartier, setIdQuartier] = useState(null);
  const onclick = (data) => {
    // console.log(data);
    setCurrent(data);
    setIdQuartier(data.IDQUARTIER);
    setValues({ ...values, nom: data.LIBELLE, contact: data.CONTACT, localisation: data.LOCALISATION, adresse: data.ADRESSE, email: data.EMAIL, num: data.NUMERO, contactp: data.CONTACTP });
  };

  const onDelete = async () => {
    // console.log('delete');
    if (window.confirm("Voulez vous supprimer?")) {
      const delet = { id: current.ID, nom: current.LIBELLE };
      // console.log(_idQuartier);
      deleteOperateurImmobilier(delet)
        .then(({ data }) => {
          setIsLoading(true);
          setFlash({ ...flash, color: "success", message: data.message });
          setCurrent(null);
          // setCommunes([]);
          // setValues({ ...values, libelle: "" });
          setValues({ ...values, nom: "", contact: "", localisation: "", adresse: "", email: "", num: "", contactp: "" });
          // listeOperateurImmobilier(values.idquartier)
          getOperateurImmobilier(values.idquartier)
            .then((res) => {
              // setCurrent(null);
              const { data } = res;
              console.log(res);
              const d = page(1, data.data);
              setCurrentTableData(d);
              // setFlash({ message, color: "success" });
              const coutPage = parseInt(data.data.length / PageSize);
              setTotalPage(coutPage);
              setOperateurImmobiliers(data.data);
              setIsLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((error) => {
          // console.log(error.response);
          setIsLoading(true);

          // setCurrent(null);
          setFlash({
            ...flash,
            color: "danger",
            message: error.response.data.message,
          });
          setOperateurImmobiliers([]);
          setValues({ ...values, libelle: "" });
          // listeOperateurImmobilier(values.idquartier)
        });
    }
  };
  useEffect(() => {
    _getPays();
  }, []);
  return (
    <Layout>
      <div className="row">
        <div className="col-xs-2" />
        <form onSubmit={handleSubmit}>
          <div className="form-horizontal col-xs-8 ui-sortable">
            <div className="widget-box widget-color-blue">
              {/* Entete du cadre */}
              <div className="widget-header ui-sortable-handle">
                <h5 className="widget-title">
                  Saisie des opérateurs immobiliers
                </h5>
              </div>
              {/* Contenu du cadre */}
              <div className="widget-body">
                <div className="widget-main">
                  {flash.message !== null && (
                    <Alert color={flash.color} message={flash.message} />
                  )}
                  <span
                    id="ContentPlaceHolder1_LBINFO"
                    style={{
                      display: "inline-block",
                      width: "100%",
                      textAlign: "center",
                    }}
                  />

                  {/* code form */}
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Pays (*)
                    </label>
                    <select
                      // name="idpays"
                      className="form-control input-xxlarge"
                      onChange={onSelectPays}
                    >
                      <option value="-1"></option>
                      {pays?.map((item, key) => (
                        <option key={key} value={item.ID}>
                          {item.NOM}
                        </option>
                      ))}
                    </select>
                  </label>
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Ville (*)
                    </label>
                    <select
                      // name="idville"
                      className="form-control input-xxlarge"
                      onChange={onSelectVille}
                    >
                      <option selected value="-1"></option>
                      {villes?.map((item, key) => (
                        <option key={key} value={item.ID}>
                          {item.LIBELLE}
                        </option>
                      ))}
                    </select>
                  </label>
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Commune (*)
                    </label>
                    <select
                      // name="idcommune"
                      className="form-control input-xxlarge"
                      onChange={onSelectCommune}
                    >
                      <option selected value="-1"></option>
                      {communes?.map((item, key) => (
                        <option key={key} value={item.ID}>
                          {item.LIBELLE}
                        </option>
                      ))}
                    </select>
                  </label>
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Quartier (*)
                    </label>
                    <select
                      name="idquartier"
                      className="form-control input-xxlarge"
                      onChange={onSelectQuartier}
                    >
                      <option selected value="-1"></option>
                      {quartiers?.map((item, key) => (
                        <option key={key} value={item.ID}>
                          {item.LIBELLE}
                        </option>
                      ))}
                    </select>
                  </label>
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Nom (*)
                    </label>
                    <input
                      name="nom"
                      value={values.nom}
                      onChange={handleChange}
                      type="text"
                      className="form-control input-xxlarge"
                    />
                  </label>
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Contacts (*)
                    </label>
                    <input
                      name="contact"
                      value={values.contact}
                      onChange={handleChange}
                      type="text"
                      className="form-control input-xxlarge"
                    />
                  </label>
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Localisation (*)
                    </label>
                    <input
                      name="localisation"
                      value={values.localisation}
                      onChange={handleChange}
                      type="text"
                      className="form-control input-xxlarge"
                    />
                  </label>
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Adresse (*)
                    </label>
                    <input
                      name="adresse"
                      value={values.adresse}
                      onChange={handleChange}
                      type="text"
                      className="form-control input-xxlarge"
                    />
                  </label>
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Email (*)
                    </label>
                    <input
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      type="text"
                      className="form-control input-xxlarge"
                    />
                  </label>
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Personne à contacter (*)
                    </label>
                    <input
                      name="contactp"
                      value={values.contactp}
                      onChange={handleChange}
                      type="text"
                      className="form-control input-xxlarge"
                    />
                  </label>
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      N° de téléphone (*)
                    </label>
                    <input
                      name="num"
                      value={values.num}
                      onChange={handleChange}
                      type="text"
                      className="form-control input-xxlarge"
                    />
                  </label>
                </div>
                {/* Pied du cadre */}
                <div className="widget-toolbox padding-8 clearfix">
                  <div className="pull-right">
                    <input
                      type="submit"
                      value="Enregistrer"
                      className="btn btn-success"
                      style={{
                        borderStyle: "None",
                        width: 100,
                        marginRight: 2,
                        marginBottom: 2,
                      }}
                    />

                    {current && (
                      <input
                        type="button"
                        value="Supprimer"
                        onClick={onDelete}
                        className="btn btn-danger"
                        style={{
                          borderStyle: "None",
                          width: 100,
                          marginRight: 2,
                          marginBottom: 2,
                        }}
                      />
                    )}
                    <input
                      type="button"
                      value="Annuler"
                      className="btn btn-warning"
                      style={{
                        borderStyle: "None",
                        width: 100,
                        marginBottom: 2,
                      }}
                      onClick={() => {
                        setCurrent(null);
                        setValues({
                          ...values,
                          nom: "",
                          idquartier: "",
                          contact: "",
                          localisation: "",
                          adresse: "",
                          email: "",
                          contactp: "",
                          num: "",
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      {isLoading ? (
        <Loading isLoading={isLoading} />
      ) : (
        <Table title={"Liste des opérateurs immobiliers"} headTable={headTable}>
          {currentTableData?.map((item, key) => (
            <tr key={key} style={{ color: "Black", backgroundColor: "White" }}>
              <td>{item.LIBELLE}</td>
              {/* <td>{item.CONTACT}</td> */}
              <td className="text-center" align="right">
                <a href="#navbar">
                  <img
                    onClick={() => onclick(item)}
                    // style={{ width: 15, height: 10 }}
                    src={"/Catef_files/modifier.png"}
                  />
                </a>
              </td>
            </tr>
          ))}
          <tr
            className="pagination-od"
            align="center"
            style={{
              color: "Black",
              backgroundColor: "#EFF3F8",
              fontWeight: "normal",
              whiteSpace: "nowrap",
            }}
          >
            <td colSpan={5}>
              {totalPage != null && (
                <ReactPaginate
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                  breakLabel="..."
                  nextLabel="suivant >"
                  onPageChange={onPageChange}
                  pageRangeDisplayed={5}
                  pageCount={totalPage + 1}
                  previousLabel="< précédent"
                  renderOnZeroPageCount={null}
                />
              )}
            </td>
          </tr>
          {/* <Pagination onPageChange={onPageChange} totalPage={totalPage} /> */}
        </Table>
      )}
    </Layout>
  );
};

export default OperateurImmobiliers;
